<template>
    <v-card v-if="value" class="mt-6 shop-product-supplies">
        <v-card-title>
            <v-row>
                <v-col class="subtitle-1 py-0">재고주문 (사용/미사용)</v-col>
                <v-col md="auto" sm="auto" class="py-0">
                    <v-switch v-model="form.enabled" dense hide-details class="mt-0" @change="emit"></v-switch>
                </v-col>
            </v-row>
        </v-card-title>
    </v-card>
</template>

<script>
import { initStockOrderConf } from "@/assets/variables";

export default {
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').StockOrderConf>} */
        value: { type: Object, default: initStockOrderConf },
    },
    data: () => ({
        form: initStockOrderConf(),
    }),
    methods: {
        sync() {
            this.form = initStockOrderConf(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
    mounted() {
        this.sync();
    },
};
</script>
